import { Link } from 'react-router-dom';
import {
  CargasPage,
  CargasSection,
  CargasViewport,
  cargasButtonClassName,
} from './components/CargasLayout.jsx';

const closedDecisions = [
  'No se crea entidad nueva para remitos de sucursal.',
  "El soporte minimo queda en guias_remitos.origen = 'SUCURSAL'.",
  'Se agregan guias_remitos.sucursal_origen_id y guias_remitos.referencia_externa para rastrear procedencia.',
];

export default function IngresoDeRemitosDeSucursal() {
  return (
    <CargasPage
      title="Ingreso de Remitos de Sucursal"
      description="La trazabilidad canonica ya tiene destino de persistencia, pero la carga operativa dedicada sigue pendiente."
      breadcrumbs={[
        { label: 'Cargas', href: '/cargas/dashboard' },
        { label: 'Operativas' },
        { label: 'Ingreso de Remitos de Sucursal' },
      ]}
      actions={<Link to="/cargas/dashboard" className={cargasButtonClassName}>Volver</Link>}
    >
      <CargasViewport className="gap-4 px-4 py-4">
        <CargasSection
          title="Estado actual"
          description="La pantalla deja de ser placeholder vacio y pasa a bloquear con mensaje claro hasta que exista backend especifico."
        >
          <div className="rounded-xl border border-[rgba(var(--warning),0.3)] bg-[rgba(var(--warning),0.12)] px-4 py-3 text-sm text-[rgb(var(--fg))]">
            Accion bloqueada: el backend actual no publica un flujo dedicado para cargar remitos de sucursal fuera de la emision normal de guias.
          </div>
        </CargasSection>

        <CargasSection
          title="Decision cerrada"
          description="Persistencia minima acordada para no abrir una entidad paralela."
        >
          <ul className="space-y-2 text-sm text-[rgba(var(--fg),0.76)]">
            {closedDecisions.map((item) => <li key={item} className="rounded-xl border border-[rgba(var(--border),0.45)] bg-[rgba(var(--subpanel),0.45)] px-3 py-2">{item}</li>)}
          </ul>
        </CargasSection>
      </CargasViewport>
    </CargasPage>
  );
}
